<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 22"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M12 21s-7.5-4.6-10.2-9.4C-.4 7.6 1.6 3 5.8 2.2 8.3 1.7 10.7 3 12 5.1 13.3 3 15.7 1.7 18.2 2.2 22.4 3 24.4 7.6 22.2 11.6 19.5 16.4 12 21 12 21z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconHeartFilled',
  props: {
    width: { type: [String, Number], default: 22 },
    height: { type: [String, Number], default: 22 },
  },
};
</script>
